module.exports = __webpack_public_path__ + "img/Imran_Ansari.71824ca5.jpeg";